import { useQuery } from '@tanstack/react-query';
import { openLocalDb } from '../db/local.js';
import {
  readLabelHistory, readLabelHistoryEvents,
  type LabelHistoryScope, type LabelHistoryEvent,
} from './history.js';

const scopeKey = (scope: LabelHistoryScope) => [scope.tenantId, scope.businessId, scope.allowLegacyUnscoped];

export function useLabelHistory(scope: LabelHistoryScope, enabled = true) {
  return useQuery({
    queryKey: ['events', 'label-history', ...scopeKey(scope)],
    networkMode: 'always',
    enabled: enabled && !!scope.tenantId,
    queryFn: async () => readLabelHistory(await openLocalDb(null), scope),
  });
}

export function useLabelHistoryEvents(scope: LabelHistoryScope, ids: readonly string[], enabled = true) {
  return useQuery({
    queryKey: ['events', 'label-history-payloads', ...scopeKey(scope), ids],
    networkMode: 'always',
    enabled: enabled && !!scope.tenantId,
    placeholderData: (previous, previousQuery) => {
      const key = previousQuery?.queryKey;
      return key?.[2] === scope.tenantId && key[3] === scope.businessId && key[4] === scope.allowLegacyUnscoped
        ? previous : undefined;
    },
    queryFn: async () => readLabelHistoryEvents(await openLocalDb(null), scope, ids),
  });
}

export async function fetchLabelHistoryEvent(scope: LabelHistoryScope, id: string): Promise<LabelHistoryEvent | null> {
  const events = await readLabelHistoryEvents(await openLocalDb(null), scope, [id]);
  return events[0] ?? null;
}
